import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageService } from '../../services/manage.service';
import { CommonService } from '../../services/common.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-comfirm-mas-sub-creation-popup',
  templateUrl: './comfirm-mas-sub-creation-popup.component.html',
  styleUrls: ['./comfirm-mas-sub-creation-popup.component.css'],
})
export class ConfirmMASSubCreationPopup implements OnInit {

  public displayName = new FormControl("", [Validators.required])
  public mpn = new FormControl("", [Validators.required])
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public loading = false;
  public doneCreation = false;

  public NoMPNText = '';
  public editMpn = false;

  public mpnList: string[] = [];

  // publis mpn

  constructor(
    private manageService: ManageService,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<ConfirmMASSubCreationPopup>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.NoMPNText = commonService.NoMPNText;
  }

  ngOnInit() {
    // this.manageService.currentMPNList.pipe(takeUntil(this.ngUnsubscribe)).subscribe((mpns) => {
    //   this.mpnList = mpns;
    // })
  }

  confirm(): void {
    this.loading = true;
    this.manageService.createAzureSubscriptionForAzurePlan(
      this.data?.tenantId?.toLocaleLowerCase(),
      this.data?.subscriptionId?.toLocaleLowerCase(),
      this.displayName.value.replace(/[^\w\s-]/gi, "") // remove all spl chars except '-' and ' '
    )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: () => {
          this.doneCreation = true
        },
        error: () => this.loading = false,
        complete: () => this.loading = false
      })
  }

  toggleMPNChange() {
    this.editMpn = !this.editMpn;
  }

  showAutoCompletePanel(trigger: any): void {
    trigger.openPanel();
  }

  close(result): void {
    this.dialogRef.close(result);
  }
}
